/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BarChart } from "../models/http/charts/bar-chart/bar-chart.model";
import { AdvancedFilters } from "../models/http/dashboard/advanced-filters.model";
import { ChartResponse } from "../models/ui/charts.model";
import { DashboardImpactHttpService } from "./http/dashboard-impact-http.service";

@Injectable({
	providedIn: "root"
})
export class DashboardImpactService {
	constructor(private _dashboardImpactHttpService: DashboardImpactHttpService) {}

	/**
	 * Retrieves 10 worst emissions layers by CO2 bar chart data within the specified date range.
	 *
	 * @param filters - The AdvancedFilters payload as defined in the cursor-based filters API spec.
	 * @returns An Observable that emits the bar chart data.
	 */
	public getWorst10Layers(filters: AdvancedFilters): Observable<ChartResponse<BarChart>> {
		return this._dashboardImpactHttpService.getWorst10Layers(filters);
	}

	/**
	 * Retrieves 10 worst emissions applications by CO2 bar chart data within a specified date range.
	 *
	 * @param filters - The AdvancedFilters payload as defined in the cursor-based filters API spec.
	 * @returns An Observable that emits the bar chart data for the worst emissions applications.
	 */
	public getWorst10Apps(filters: AdvancedFilters): Observable<ChartResponse<BarChart>> {
		return this._dashboardImpactHttpService.getWorst10Apps(filters);
	}

	public downloadAsCsv(startDate: string, endDate: string): Observable<Blob> {
		return this._dashboardImpactHttpService.downloadAsCsv(startDate, endDate);
	}
}
